import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "../../../helpers/pipes/pipes.module";
import { DatePickerPopoverComponent } from "./date-picker-popover.component";

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        PipesModule,
        TranslateModule,
    ],
    declarations: [
        DatePickerPopoverComponent,
    ],
    exports: [
        DatePickerPopoverComponent,
    ],
})
export class DatePickerPopoverModule {
}
